/* eslint-disable react-hooks/exhaustive-deps */
import { useRef, useEffect, SyntheticEvent } from 'react'
import videojs from 'video.js'
import { Container } from './styles'
import videojsqualityselector from 'videojs-hls-quality-selector'
import 'videojs-contrib-quality-levels'
import 'videojs-seek-buttons'

export const VideoPlayer = (props) => {
  const videoRef = useRef(null)
  const playerRef = useRef(null)
  const { options, onReady } = props

  const timeRef = useRef(null)

  const updateCurrentTime = (event: SyntheticEvent<HTMLVideoElement, Event>) => {
    const currentTime = Math.floor(event.currentTarget.currentTime || 0)

    if (timeRef.current !== currentTime) {
      props.setCurrentTime(currentTime)
      timeRef.current = currentTime
    }
  }

  useEffect(() => {
    let player: any
    if (videoRef) {
      player = videojs(videoRef.current, options, () => {
        onReady && onReady(player)

        player.hlsQualitySelector = videojsqualityselector
        player.qualityLevels()
        player.hlsQualitySelector()

        player.on('downloadvideo', function () {
          console.log('downloadvideo triggered')
        })
      })
    }

    return () => {
      if (document.pictureInPictureElement) {
        document
          .exitPictureInPicture()
          .then(() => console.log('Document Exited from Picture-in-Picture mode'))
          .catch((err) => console.error(err))
      } else {
        player.requestPictureInPicture()
      }

      player.dispose()
    }
  }, []) // Este segundo argumento do useEffect deve ficar vazio

  useEffect(() => {
    const qualitySelectorTitle = document.querySelectorAll('.vjs-menu-title')[1]

    if (qualitySelectorTitle) qualitySelectorTitle.textContent = 'Qualidade'
  }, [document.querySelectorAll('.vjs-menu-title')[1]])

  useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <Container data-vjs-player>
      <video
        disablePictureInPicture
        ref={videoRef}
        className="video-js vjs-big-play-centered vjs-theme-forest"
        id="videoPlayer"
        onTimeUpdate={updateCurrentTime}
        onEnded={updateCurrentTime}
      />
    </Container>
  )
}

export default VideoPlayer
